import _ from 'lodash';
import customFilterColumnsExtend from '../custom_filter_columns_extend';
import { columnsExtend as entityColumnsExtend, formColumnsExtend as entityFormColumnsExtend } from '../admin_entities/jushuitan_after_sale_detail.js';
import { shareColumnsExtend } from './share';
export const filterColumns = {
  outer_as_id_cont: {
    model_name: 'JushuitanAfterSale',
    column_type: 'string',
    column_name: 'outerAsId',
  },
  so_id_cont: {
    model_name: 'JushuitanAfterSale',
    column_type: 'string',
    column_name: 'soId',
  },
  status_eq: {
    model_name: 'JushuitanAfterSale',
    column_type: 'string',
    column_name: 'status',
  },
  shop_id_eq: {
    column_type: 'belongs_to',
    column_name: 'shop',
    extra: {
      model_name: 'JushuitanShop',
      value_column: 'shop_id',
    },
    model_name: 'JushuitanAfterSale',
  },
  shop: {
    column_type: 'belongs_to',
    column_name: 'shop',
    extra: {
      model_name: 'JushuitanShop',
      value_column: 'shop_id',
    },
    model_name: 'JushuitanAfterSale',
  },
  status_in: {
    model_name: 'JushuitanAfterSale',
    column_type: 'string',
    column_name: 'status',
  },
  order_o_id_eq: {
    model_name: 'JushuitanOrder',
    column_type: 'string',
    column_name: 'oId',
  },
  related: {
    model_name: 'JushuitanAfterSale',
    column_type: 'string',
    column_name: 'related',
  },
  created_gteq_date: {
    column_type: 'datetime',
    model_name: 'JushuitanAfterSale',
    column_name: 'created',
  },
  created_lteq_date: {
    column_type: 'datetime',
    model_name: 'JushuitanAfterSale',
    column_name: 'created',
  },
  confirm_date_gteq: {
    column_type: 'date',
    model_name: 'JushuitanAfterSale',
    column_name: 'confirmDate',
  },
  confirm_date_lteq: {
    column_type: 'date',
    model_name: 'JushuitanAfterSale',
    column_name: 'confirmDate',
  },
  order_user_id_not_null: {
    column_type: 'boolean',
    model_name: 'JushuitanOrder',
    column_name: 'userId',
  },
  user_team_id_eq: {
    model_name: 'JushuitanAfterSale',
    column_type: 'string',
    column_name: 'userTeamIdEq',
  },
  customer_id_eq: {
    column_type: 'belongs_to',
    column_name: 'customer',
    extra: {
      model_name: 'Customer',
      value_column: 'id',
    },
    model_name: 'JushuitanOrder',
  },
  customer: {
    column_type: 'belongs_to',
    column_name: 'customer',
    extra: {
      model_name: 'Customer',
      value_column: 'id',
    },
    model_name: 'JushuitanOrder',
  },
  customer_user_id_eq: {
    column_type: 'belongs_to',
    column_name: 'user',
    extra: {
      model_name: 'User',
      value_column: 'id',
    },
    model_name: 'JushuitanOrder',
  },
  user: {
    column_type: 'belongs_to',
    column_name: 'user',
    extra: {
      model_name: 'User',
      value_column: 'id',
    },
    model_name: 'JushuitanOrder',
  },
  customer_customer_source_id_eq: {
    column_type: 'belongs_to',
    column_name: 'customer_source',
    extra: {
      model_name: 'CustomerSource',
      value_column: 'id',
    },
    model_name: 'Customer',
  },
  customer_source: {
    column_type: 'belongs_to',
    column_name: 'customer_source',
    extra: {
      model_name: 'CustomerSource',
      value_column: 'id',
    },
    model_name: 'Customer',
  },
  customer_customer_source_id_in: {
    column_type: 'has_many',
    model_name: 'JushuitanOrder',
    extra: {
      model_name: 'Customer',
      value_column: 'customer_source_id',
    },
    column_name: 'customerSourceId',
  },
  customer_customer_level_id_eq: {
    column_type: 'belongs_to',
    column_name: 'customer_level',
    extra: {
      model_name: 'CustomerLevel',
      value_column: 'id',
    },
    model_name: 'Customer',
  },
  customer_level: {
    column_type: 'belongs_to',
    column_name: 'customer_level',
    extra: {
      model_name: 'CustomerLevel',
      value_column: 'id',
    },
    model_name: 'Customer',
  },
  customer_customer_tags_id_eq: {
    model_name: 'CustomerTag',
    column_type: 'string',
    column_name: 'id',
  },
  customer_customer_business_models_id_eq: {
    model_name: 'CustomerBusinessModel',
    column_type: 'string',
    column_name: 'id',
  },
}
export const formColumnsConfig = {
 'self': {}
}

export const filterColumnsExtend = (columns) => {
  const customColumns = customFilterColumnsExtend(filterColumns)

  return columns.map(hash => {
    if (typeof hash === 'string') {
      return customColumns[hash]
    } else if (hash['key']) {
      return _.merge(customColumns[hash['key']], hash)
    } else {
      return hash
    }
  })
}

export const columnsExtend = (columns) => {
  return entityColumnsExtend(shareColumnsExtend('JushuitanAfterSale', columns))
}

export const formColumnsExtend = (columns, { data, type }) => {
  return _.map(entityFormColumnsExtend(shareColumnsExtend('JushuitanAfterSale', columns), { data, type, formColumnsConfig: formColumnsConfig['self'] }))
}
